import { Button, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import React from "react";
import { FormatPrice } from "../../../utils/constants";





export const ListadoPropuestas = ({
    data=[],
    onAcceptSolicitud = ()=>{},
    cod_solicitud
})=>{
    console.log({data});
    return (
        <>
        <Typography variant="h6" >
            Listado de propuestas de servicio
        </Typography>
            <Table>

                <TableHead>
                    <TableRow>
                            <TableCell>Proveedor</TableCell>
                            <TableCell>Tipo proveedor</TableCell>
                            <TableCell>valor</TableCell>
                            <TableCell>Cargue</TableCell>
                            <TableCell>Descarge</TableCell>
                            <TableCell>Tipo de vehiculo</TableCell>
                            <TableCell>Placa</TableCell>
                            <TableCell>Estado</TableCell>
                            <TableCell>Acciones</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        data.map( item=>
                        <TableRow key={item.cod} >
                            
                            <TableCell>{item.empresa_nombre}</TableCell>
                            <TableCell>{item.empresa_tipo}</TableCell>
                            <TableCell>{FormatPrice( item.valor )}</TableCell>
                            <TableCell>{item.incluye_cargue}</TableCell>
                            <TableCell>{item.incluye_descargue}</TableCell>
                            <TableCell>{item.vehiculo}</TableCell>
                            <TableCell>{item.placa_vehiculo}</TableCell>
                            <TableCell>{item.ind_estado}</TableCell>
                            <TableCell>
                                <Stack direction={"row"} justifyContent={"center"} alignContent={"center"} alignItems={"center"}  >
                                    <Button 
                                    disabled={item.ind_estado !== 'ENVIADA'}
                                    onClick={e=>onAcceptSolicitud(cod_solicitud,item.cod)} 
                                    size="small" 
                                    variant="contained" 
                                    color="primary" 
                                    sx={{marginLeft:1}}  >Aceptar</Button>
                                </Stack>
                            </TableCell>

                        </TableRow> )
                    }
                    
                </TableBody>

            </Table>
        </>
    )
}